import { SliderComponent } from '@webentorCore/_slider';

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll(
    '.b-features-video-slider .js-slider',
  );

  sliders.forEach((element) => {
    const params = JSON.parse(element.getAttribute('data-slider') || '{}');
    const sliderInstance = new SliderComponent(element, params);
    const swiper = sliderInstance.getSwiper();
    if (!swiper) return;

    const videos = Array.from(
      element.querySelectorAll<HTMLVideoElement>('.js-slide-video'),
    );
    const points = Array.from(
      element.querySelectorAll<HTMLElement>('.progress-point'),
    );
    let currentVideo: HTMLVideoElement | null = null;

    // Activate a video by index
    function activateVideo(index: number) {
      // Pause all videos
      videos.forEach((v) => {
        v.pause();
        v.currentTime = 0;
      });

      // Highlight the active pagination point
      points.forEach((p, i) => p.classList.toggle('is-active', i === index));

      const video = videos[index];
      if (!video) return;

      const src =
        window.innerWidth <= 480 ? video.dataset.mobile : video.dataset.desktop;
      if (!src) return;

      if (video.src !== src) {
        video.src = src; // Lazy load
        video.load();
      }

      currentVideo = video;

      const tryPlay = () => {
        video.muted = true;
        video.play().catch(() => {});
      };

      if (video.readyState >= 2) tryPlay();
      else {
        video.addEventListener('loadedmetadata', tryPlay, { once: true });
        video.addEventListener('canplay', tryPlay, { once: true });
      }

      // On video end, move to next slide and play next video
      video.onended = () => {
        const nextIndex = (index + 1) % videos.length;
        swiper.slideToLoop(nextIndex, 300);
        activateVideo(nextIndex);
      };
    }

    // Load and play the first video on page load
    function loadFirstVideo() {
      const firstVideo = videos[0];
      if (!firstVideo) return;

      const src =
        window.innerWidth <= 480
          ? firstVideo.dataset.mobile
          : firstVideo.dataset.desktop;
      if (!src) return;

      if (firstVideo.src !== src) {
        firstVideo.src = src;
        firstVideo.load();
      }

      const tryPlay = () => {
        firstVideo.muted = true;
        firstVideo.play().catch(() => {});
        activateVideo(0);
      };

      if (firstVideo.readyState >= 2) tryPlay();
      else {
        firstVideo.addEventListener('loadedmetadata', tryPlay, { once: true });
        firstVideo.addEventListener('canplay', tryPlay, { once: true });
      }
    }

    // Initialize Swiper if not yet initialized
    if (!swiper.initialized && swiper.init) swiper.init();

    // Handle first video load depending on Swiper state
    if (!swiper.initialized) {
      swiper.once('init', loadFirstVideo);
    } else {
      loadFirstVideo();
    }

    // Update video on slide change
    swiper.on('slideChangeTransitionStart', () => {
      activateVideo(swiper.realIndex || 0);
    });

    // Play/pause toggle on video click
    videos.forEach((video) => {
      video.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => {});
        else video.pause();
      });
    });

    // Resize handler: only reload video if source changes
    window.addEventListener('resize', () => {
      if (!currentVideo) return;

      const src =
        window.innerWidth <= 480
          ? currentVideo.dataset.mobile
          : currentVideo.dataset.desktop;
      if (!src || currentVideo.src === src) return;

      currentVideo.src = src;
      currentVideo.load();
      currentVideo.addEventListener(
        'loadedmetadata',
        () => currentVideo?.play().catch(() => {}),
        { once: true },
      );
    });
  });
});
